import React, {Component} from 'react';
import overlayFactory from "react-bootstrap-table2-overlay";
import BootstrapTable from 'react-bootstrap-table-next';
import Dropdown from '../base/dropdown';
import Modal from '../base/modal';
import Select from 'react-select'
import {connect} from 'react-redux';


import api from '../../utils/api';
import EmptyRow from "./../../components/EmptyRow"
import {helpers} from "../../utils/helpers";
import Header from '../base/header';
import _ from "lodash";
import paginationFactory from "react-bootstrap-table2-paginator";
import {toast} from "react-toastify";
import {ajaxHandler} from "../../utils/errors";


const color = '#dd1d21';

const customStyles = {
  option: (base, state) => ({
    ...base,
    borderBottom: `1px solid #d8d8d8`,
    color: '#59595a',
    backgroundColor: '#fff',
    padding: 0,
    '&:hover': {
      backgroundColor: 'rgba(220,136,126,0.2) !important',
      color: '#d8d8d8'
    },
  }),

  control: base => ({
    ...base,
    borderColor: '#d8d8d8',
    boxShadow: "none",
    height: 25,
    marginTop: 7
  })
}

class Admin extends Component {

  constructor(props) {
    super(props);
    this.state = {
      users: false,
      count: 0,
      xhr: false,
      page: 1,
      sortBy: '',
      name: [{id: 0, label: "Nombre"}],
      nameValue: '',
      lastName: [{id: 0, label: "Apellido"}],
      lastNameValue: '',
      username: [{id: 0, label: "Usuario"}],
      usernameValue: '',
      email: [{id: 0, label: "Email"}],
      emailValue: '',
      modalNewUserVisible: false,
      nameInput: '',
      lastNameInput: '',
      usernameInput: '',
      emailInput: '',
      errors: '',
      found: false,
      migrate: false,
      selectedOption: '',
      role_id: '',
      userSelected: false,
      finishedFirstFetch: false,
      xhrModal: false
    }
  }

  componentDidMount() {
    this.fetchUsers();
  }

  fetchUsers = () => {
    this.setState({xhr: true});
    let url = 'users/?';
    if (this.state.page && this.state.page > 1) {
      url += `page=${this.state.page}&`;
    }
    if (this.state.sortBy !== '') {
      url += `ordering=${this.state.sortBy}&`;
    }
    if (this.state.nameValue !== '') {
      url += `first_name__icontains=${this.state.nameValue}`
    }
    if (this.state.lastNameValue !== '') {
      url += `last_name__icontains=${this.state.lastNameValue}`
    }
    if (this.state.usernameValue !== '') {
      url += `username__icontains=${this.state.usernameValue}`
    }
    if (this.state.emailValue !== '') {
      url += `email__icontains=${this.state.emailValue}`
    }
    api.get(url).then(out => {
      let data = out.data;
      this.setState({users: data.results, count: data.count, xhr: false, finishedFirstFetch: true})
    })
  };

  _onTableChange = (type, {page, sizePerPage, filters, sortField, sortOrder}) => {
    if (type === 'pagination') {
      this.setState({page}, this.fetchUsers);
    } else if (type === 'sort') {
      this.setState({
        page: 1,
        sortBy: `${sortOrder === 'asc' ? '' : '-'}${sortField}`,
      }, this.fetchUsers);
    }
  };

  getRoles = (user) => {
    let roles = "";
    if (user.profile) {
      user.profile.roles.forEach((rol, index) => {
        if (index !== user.profile.roles.length - 1) {
          roles += rol + ", ";
        } else {
          roles += rol;
        }
      })
    } else {
      roles = "-";
    }
    return roles;
  };

  getGroups = () => {
    return this.props.groups.map((group) => {
      return {value: group.id, label: group.display_name}
    })
  }

  autocompleteName = (search) => {
    this.setState({nameValue: search, page: 1}, this.fetchUsers);
  };

  autocompleteLastName = (search) => {
    this.setState({lastNameValue: search, page: 1}, this.fetchUsers);
  };

  autocompleteUsername = (search) => {
    this.setState({usernameValue: search, page: 1}, this.fetchUsers);
  };

  autocompleteEmail = (search) => {
    this.setState({emailValue: search, page: 1}, this.fetchUsers);
  };

  createUser = () => {

    let data = this.state.found ? {
        first_name: this.state.nameInput,
        last_name: this.state.lastNameInput,
        username: this.state.usernameInput,
        email: this.state.emailInput,
        role_id: this.state.role_id,
        migrate: true
      } :
      {
        first_name: this.state.nameInput,
        last_name: this.state.lastNameInput,
        username: this.state.usernameInput,
        email: this.state.emailInput,
        role_id: this.state.role_id
      };

    const NEW_USER = `create_user/`;
    Object.keys(data).forEach(key => {
      if (data[key] === '') {
        data[key] = null;
      }
    });
    api.post(`${NEW_USER}`, data)
      .then(response => {
        this._onSubmitSuccess();
      })
      .catch((error) => this._onSubmitError(error));
  };

  validateUser = () => {
    if (this.state.usernameInput === '' || this.state.nameInput === '' || this.state.lastNameInput === '' ||
      this.state.emailInput === '' || this.state.role_id === '') {
      window.Materialize.toast("Por favor, complete todos los datos.", 3000);
      this.setState({xhrModal: false})
      return false;
    }

    if (!helpers.isValidEmail(this.state.emailInput)) {
      window.Materialize.toast("El formato del email es incorrecto", 3000);
      this.setState({xhrModal: false})
      return false;
    }

    const VALIDATE_USER = `validate_user/?username=${this.state.usernameInput}&email=${this.state.emailInput}`;
    api.get(VALIDATE_USER)
      .then(response => {
        if (Object.keys(response.data).length === 0) {
          this.createUser();
        } else {
          let user = response.data;
          this.setState({
            nameInput: user.first_name,
            lastNameInput: user.last_name,
            usernameInput: user.username,
            emailInput: user.email,
            found: true,
            xhrModal: false
          });
        }
      })
      .catch(this._onSubmitError);
  }

  _onSubmitError = (error) => {
    let ajaxErrors = ajaxHandler(error);
    if (ajaxErrors instanceof Array) {
      let error_list = ajaxErrors.find(error => error.key === 'error_lists');
      if (error_list) {
        let errors = error_list.text.map(each => {
          return `${each.error}`
        });
        this.setState({errors});
      } else {
        let errors = ajaxErrors.map(each => {
          return `${each.text}`
        });
        this.setState({errors});
      }
    } else {
      this.setState({
        nameInput: '',
        lastNameInput: '',
        usernameInput: '',
        emailInput: '',
        found: false,
        selectedOption: ''
      });
      toast.error('No se pudo crear el usuario. ');
    }
  };

  _onSubmitSuccess = () => {
    this.setState({
      nameInput: '',
      lastNameInput: '',
      usernameInput: '',
      emailInput: '',
      found: false,
      role_id: '',
      selectedOption: '',
      xhrModal: false
    });
    this.refs.modalNewUser.hide();
    toast.success('Usuario creado correctamente.')
  };

  openNewUserModal = () => {
    this.setState({
      nameInput: '',
      lastNameInput: '',
      usernameInput: '',
      emailInput: '',
      found: false,
      role_id: '',
      selectedOption: '',
      errors: '',
      xhrModal: false
    });
    this.refs.modalNewUser.show();
  };

  actionItem = (item, action) => {
    this.setState({userSelected: item, xhrModal: false}, () => {
      if (action === 'delete') {
        this.refs.modalDeleteUser.show();
      } else {
        let user = this.state.users.find(user => user.pk === item.id);
        if (user) {
          let role_id = '';
          let selectedOption = '';
          let profile = user.profile;
          if (profile && profile.groups){
            role_id = profile.groups[0].id;

            let groups = this.getGroups()
            selectedOption = groups.find(group => group.value === role_id)
          }
          this.refs.modalNewUser.show();
          this.setState({
            nameInput: item.first_name,
            lastNameInput: item.last_name,
            usernameInput: item.username,
            emailInput: item.email,
            role_id,
            selectedOption,
            errors: ''
          });
        }
      }
    });
  };

  actionColumn = (cell, item) => {
    return (
      <div className={"action-images"}>
        <i className="material-icons shell-red-text"
           onClick={() => this.actionItem(item, 'edit')}>edit</i>
        <i className="material-icons shell-red-text"
           onClick={() => this.actionItem(item, 'delete')}>delete</i>
      </div>
    )
  };

  deleteUser = () => {
    let url = `profile/id/${this.state.userSelected.id}`;
    api.delete(url).then(out => {
      this.fetchUsers();
      this.refs.modalDeleteUser.hide();
      this.setState({userSelected: false});
    })
      .catch(() => {
        window.Materialize.toast("No se pudo borrar al usuario, intentelo nuevamente", 3000);
        this.setState({userSelected: false});
      })


  };

  updateUser = () => {
    let url = `profile/id/${this.state.userSelected.id}`;
    api.put(url, {role_id: this.state.role_id}).then(out => {
      this.fetchUsers();
      this.refs.modalNewUser.hide();
      this.setState({userSelected: false, xhrModal: false});
    }).catch(() => {
      window.Materialize.toast("No se pudo editar al usuario, intentelo nuevamente", 3000);
      this.setState({userSelected: false, xhrModal: false});
    })
  };

  render() {
    let columns = helpers.getAdminColumns();
    columns.push({
      text: '',
      dataField: 'actions',
      formatter: this.actionColumn
    });
    let data = [];
    if (this.state.users && this.state.users instanceof Array) {
      this.state.users.forEach(user => {
        let row = {id: user.pk};
        columns.forEach(col => {
          if (!col.isCustom) {
            row[col.dataField] = _.get(user, col.path, '-');
            if (!row[col.dataField] || row[col.dataField] === '') {
              row[col.dataField] = '-';
            }
          } else {
            switch (col.path) {
              case 'profile':
                row[col.dataField] = this.getRoles(user);
                break;
              default:
                row[col.dataField] = '-'
            }
          }

        });
        data.push(row);
      });
    }
    const pagination = paginationFactory({
      page: this.state.page,
      sizePerPage: this.state.users.length,
      totalSize: this.state.count,
      hideSizePerPage: true
    });

    let confirmUserEditCreate = {
      text: 'CONFIRMAR',
      click: () => {
        this.setState({
          xhrModal: true
        }, () => {
          if (this.state.userSelected) {
            this.updateUser();
          } else {
            if (this.state.found) {
              this.createUser()
            } else {
              this.validateUser();
            }
          }
        })

      }
    };

    let deleteUser = {
      text: 'CONFIRMAR',
      click: () => {
        this.deleteUser()
      }
    };

    let updateUser = {
      text: 'CONFIRMAR',
      click: () => {
        this.updateUser()
      }
    };

    let cancel = {
      text: 'CANCELAR',
      click: () => {
        this.setState({
          userSelected: false, errors: '', found: false
        });
        this.refs.modalNewUser.hide();
        this.refs.modalDeleteUser.hide();
      }
    };

    return (
      <div>

        <Modal ref="modalDeleteUser" visible={this.state.modalNewUserVisible}
               title={"Eliminar Usuario"}
               save={deleteUser}
               cancel={cancel}
        >
          <div style={{paddingBottom: 20}}>
            ¿Está seguro que desea eliminar el usuario?
          </div>
        </Modal>

        <Modal ref="modalNewUser" visible={this.state.modalNewUserVisible}
               title={this.state.userSelected ? 'Editar Usuario' : 'Nuevo Usuario'}
               save={confirmUserEditCreate}
               cancel={cancel}
               hideButtons={this.state.xhrModal}
        >

          {this.state.found &&
          <div style={{paddingBottom: 20}}>
            ¡Atención! Este es un usuario ya registrado en las herramientas de la plataforma, si desea
            continuar se importarán datos del usuario y se le asignará el perfil asignado dentro de la
            herramienta
          </div>
          }
          {this.state.errors &&
          <div style={{paddingBottom: 20}}>
            <div className={"title"} style={{color: 'dd1d21'}}>ERRORES</div>
            {this.state.errors.map(error => {
              return <li>{error}</li>
            })}
          </div>
          }
          <div className={"modal-text-value"}>
            <div className="red-text"> Nombre</div>
            <input type="text" placeholder="Nombre" value={this.state.nameInput}
                   readOnly={this.state.userSelected ? 'readonly' : ''}
                   onChange={ev => this.setState({
                     nameInput: ev.target.value,
                   })}/>
          </div>
          <div className={"modal-text-value"}>
            <div className="red-text"> Apellido</div>
            <input type="text" placeholder="Apellido" value={this.state.lastNameInput}
                   readOnly={this.state.userSelected ? 'readonly' : ''}
                   onChange={ev => this.setState({
                     lastNameInput: ev.target.value,
                   })}/>
          </div>
          <div className={"modal-text-value"}>
            <div className="red-text"> Usuario</div>
            <input type="text" placeholder="Usuario"
                   value={this.state.usernameInput}
                   readOnly={this.state.userSelected ? 'readonly' : ''}
                   onChange={ev => this.setState({
                     usernameInput: ev.target.value,
                   })}/>
          </div>
          <div className={"modal-text-value"}>
            <div className="red-text"> Email</div>
            <input type="text" placeholder="Email"
                   value={this.state.emailInput}
                   readOnly={this.state.userSelected ? 'readonly' : ''}
                   onChange={ev => this.setState({
                     emailInput: ev.target.value,
                   })}/>
          </div>
          <div className={'modal-text-value'} style={{height: 50}}>
            <div className="red-text"> Perfil</div>
            <div className={"div-select"}>
              <Select
                classNamePrefix={"rselect"}
                className={"select-profile"}
                options={this.getGroups()}
                value={this.state.selectedOption}
                isSearchable={false}
                placeholder={'Seleccione una opción'}
                styles={customStyles}
                onChange={options => {
                  this.setState({selectedOption: options, role_id: options.value})
                }}
              />
            </div>
          </div>
        </Modal>

        <Header history={this.props.history}/>
        <div className={"col s12"}>
          <div className={"row"}>
            <div className={"col s10"}/>
            <div className={"col s2"}>
              <button className="cta" href="#" onClick={this.openNewUserModal}>
                <span>Nuevo Usuario</span>
              </button>
            </div>
          </div>
        </div>
        <section className="simulador" style={{paddingTop: 0, marginTop: -20}}>
          <div className={"col s12 filters-admin"}>
            <div style={{marginBottom: 10, fontWeight: '600'}}>Filtrar por</div>
            <div className="row">
              <div className="col s2" style={{marginLeft: '-0.75rem'}}>
                <Dropdown forceActive ref="dpump" autocomplete={this.autocompleteName} text=''
                          items={this.state.name} noIcon getItem={() => {
                }}/>
              </div>
              <div className="col s2 ">
                <Dropdown forceActive ref="dpump" autocomplete={this.autocompleteLastName} text=''
                          items={this.state.lastName} noIcon getItem={() => {
                }}/>
              </div>
              <div className="col s3 ">
                <Dropdown forceActive ref="dpump" autocomplete={this.autocompleteEmail} text=''
                          items={this.state.email} noIcon getItem={() => {
                }}/>
              </div>
              <div className="col s2 ">
                <Dropdown forceActive ref="dpump" autocomplete={this.autocompleteUsername} text=''
                          items={this.state.username} noIcon getItem={() => {
                }}/>
              </div>

            </div>
          </div>
          <div className={'main-table admin-table'} style={{marginTop: 20}}>
            {this.state.finishedFirstFetch &&
            <BootstrapTable
              remote
              keyField='id'
              bordered={true}
              data={data}
              columns={columns}
              pagination={pagination}
              noDataIndication={() => {
                return <EmptyRow text={"No hay información disponible"}/>
              }}
              loading={this.state.xhr}
              overlay={overlayFactory({
                spinner: true,
                background: 'rgba(192,192,192,0.85)',
                text: 'Cargando usuarios...',
              })}
              onTableChange={this._onTableChange}
            />}
          </div>
        </section>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    groups: state.groups
  }
};
export default connect(mapStateToProps)(Admin);



// WEBPACK FOOTER //
// ./src/containers/admin/admin.js